query PaymentShow($id: ID!) {
  payment(id: $id) {
    id
    platformId
    organizationId
    userId
    status
    provider
    providerPaymentId
    providerTransactionId
    recurrent
    period
    promocodeId
    country
    city
    buyerEmail
    createdAt
    updatedAt
    metadata
    providerPaymentData
    amount {
      value
      currency
      valueUSD
    }
    amountInOrganizationCurrency {
      value
      currency
      valueUSD
    }
    providerFeeAmount {
      value
      currency
      valueUSD
    }
    ottkitFeeAmount {
      value
      currency
      valueUSD
    }
    feeAmount {
      value
      currency
      valueUSD
    }
    organizationAmount {
      value
      currency
      valueUSD
    }
    organizationAmountInOrganizationCurrency {
      value
      currency
      valueUSD
    }
    feeSettings {
      feeType
      percentageFee
      fixedFeeAmount {
        value
        currency
      }
      providerFeePayer
    }
    organization {
      id
      title
    }
    platform {
      id
      title
    }
    buyer {
      id
      email
      displayName
    }
    purchase {
      id
      type
      startAt
      expiredAt
    }
    product {
      id
      title
      type
    }
  }
}
